<script setup>
import { SelectLabel, } from 'radix-vue';
import { cn, } from '@/utils/ShadcnUtil';

const props = defineProps({
  for: { type: String, required: false, default: '' },
  asChild: { type: Boolean, required: false, default: false },
  as: { type: null, required: false, default: 'div' },
  class: { type: null, required: false, default: '' },
});
</script>

<template>
  <SelectLabel
    :class="cn('py-1.5 px-1 text-sm font-semibold', props.class)"
  >
    <slot />
  </SelectLabel>
</template>
